module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("WOULD")]), _c('span', {
    staticClass: "t4"
  }), _vm._v("like to thank Willie Larson and the helpful staff of Hennepin County Medical Center for the wonderful input and advice I received. HCMC rocks! ")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Thanks to Kristopher Krentz (aka Str8 Cat) for his insightful scene input and character embellishment. ")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Mucho thanks to my eagle-eyed beta readers: Ann Hinnenkamp, James (aka Pearle) Gunderson, and Jennifer Hutchins—their helpful notes and suggestions were invaluable. ")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("A special thank you to Jennifer Hutchins, who tackled the bulk of the research for this book. It was a collaboration I will cherish forever. ")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("A hug to my partner, Patrick (aka “P”) for extending the leash. You are and always will be the sparkle in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0